const colors = {
    parimary: '#1eb980',
    dark: '#007d51',
    light: '#37efba',
    darkMore: '#005d57',
    red: '#b00020'
}
export default colors;
